import { AppState } from 'react-native';

/**
 * iOS pauses the app soon after it goes to the background, so an upload
 * running then breaks. Coming back picks it up again on its own: `resume`
 * runs once the app is active and the broken run has ended (the parts Voltr
 * already has are skipped, and the checksum is reused). Uploading while
 * backgrounded would need native code and a new build.
 */
export function resumeOnReturn(isRunning: () => boolean, resume: () => void): { runEnded(): void } {
  let interrupted = false;
  const tryResume = () => {
    if (!interrupted || isRunning() || AppState.currentState !== 'active') return;
    interrupted = false;
    resume();
  };
  AppState.addEventListener('change', (state) => {
    if (state === 'background' && isRunning()) interrupted = true;
    if (state === 'active') tryResume();
  });
  return { runEnded: () => setTimeout(tryResume, 0) };
}
